import { RecordEmployeeType } from "ui/Scripts/source/models/enums";

export interface IUserImportItem {
    userCode: string;
    firstName: string;
    lastName: string;
    endDate: number;
    email: string;
    userGroupName: string;
    defaultCulture: string;
    recordUser: boolean;
    employeeType: RecordEmployeeType;
    unitName: string;
    postalAddress: string;
    postalCode: string;
    city: string;
    phone: string;
    taxNumber: string;
    workShiftName: string;
    comment: string;
    companyName: string;
    startDate: number;
    jobTitle: string;
}

export class UserImportItem implements IUserImportItem {
    userCode: string;
    firstName: string;
    lastName: string;
    endDate: number;
    email: string;
    userGroupName: string;
    defaultCulture: string;
    recordUser: boolean;
    employeeType: RecordEmployeeType;
    unitName: string;
    postalAddress: string;
    postalCode: string;
    city: string;
    phone: string;
    taxNumber: string;
    workShiftName: string;
    comment: string;
    companyName: string;
    startDate: number;
    jobTitle: string;

    constructor();
    constructor(obj: IUserImportItem);
    constructor(obj?: any) {
        this.userCode = obj && obj.userCode || "";
        this.firstName = obj && obj.firstName || "";
        this.lastName = obj && obj.lastName || "";
        this.endDate = obj && obj.endDate || null;
        this.email = obj && obj.email || "";
        this.userGroupName = obj && obj.userGroupName || "";
        this.defaultCulture = obj && obj.defaultCulture || "";
        this.recordUser = obj && obj.recordUser || false;
        this.employeeType = obj && obj.employeeType || RecordEmployeeType.Employee;
        this.unitName = obj && obj.unitName || "";
        this.postalAddress = obj && obj.postalAddress || "";
        this.postalCode = obj && obj.postalCode || "";
        this.city = obj && obj.city || "";
        this.phone = obj && obj.phone || "";
        this.taxNumber = obj && obj.taxNumber || "";
        this.workShiftName = obj && obj.workShiftName || "";
        this.comment = obj && obj.comment || "";
        this.companyName = obj && obj.companyName || "";
        this.startDate = obj && obj.startDate || null;
        this.jobTitle = obj && obj.jobTitle || "";
    }
}